import React from "react";
import { useTranslation } from "components/translations/useTranslation";
import { mapErrorMessage } from "utils/errorHandle.function";
import OneButtonModalFooter from "components/modals/OneButtonModalFooter";
import { MODAL_CONTENT_TAB_INDEX } from "utils/constants";

interface ErrorModalProps {
    more: { error: unknown };
    closeModal: () => void;
    loopFocus: () => void;
    initialFocusRef?: (element: HTMLElement | null) => void;
}

const ErrorModal = ({ more, closeModal, loopFocus, initialFocusRef }: ErrorModalProps): React.ReactElement => {
    const { translate } = useTranslation();
    const errorMessage = mapErrorMessage(more.error);

    return (
        <>
            <div className="ga-modal__content">
                <div className="modal-body">
                    <p>{errorMessage}</p>
                </div>
            </div>
            <OneButtonModalFooter
                tabIndex={MODAL_CONTENT_TAB_INDEX + 1}
                enabled={true}
                callback={closeModal}
                text={translate("popUp.cancel")}
                loopFocus={loopFocus}
                buttonRef={initialFocusRef}
            />
        </>
    );
};

export default ErrorModal;
